import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class LocalStorageService {
  public storage: Storage;

  constructor() {
    this.storage = window.localStorage;
  }

  public setItem(key: string, value: any): boolean {
    if (this.storage) {
      this.storage.setItem(key, value);
      return true;
    }
    return false;
  }

  public getItem(key: string): any {
    return this.storage.getItem(key);
  }

  public removeItem(key: string): boolean {
    if (this.storage) {
      this.storage.removeItem(key);
      return true;
    }
    return false;
  }

  public clearAll(): boolean {
    if (this.storage) {
      this.storage.clear();
      return true;
    }
    return false;
  }

  // Método específico para gerenciar cmdNameActually
  public setCmdNameActually(cmdName: string): boolean {
    return this.setItem('cmdNameActually', cmdName);
  }

  public getCmdNameActually(): string {
    return this.getItem('cmdNameActually') || '';
  }

  public clearCmdNameActually(): boolean {
    return this.removeItem('cmdNameActually');
  }
}
